/**
 * Implements functionality which allows submission of a hidden form
 * which passes the selected checkboxes depending
 * if a container exist or not
 */
var FIRST_TWO_LETTERS = 2;

function handleChecked() {
  var $billing_container = $('.billing_statements');
  var $form = $('form.export-vals');
  var $alertBox = $('body').find('.alert-warning-light.export');

  function showAlert() {
    $alertBox.removeClass('hidden');
  }

  function hideAlert() {
    $alertBox.addClass('hidden');
  }

  function listenToSubmit() {
    function getSubstring(name) {
      return name.substring(0, FIRST_TWO_LETTERS);
    }

    $('button.export').on('click', function (e) {
      hideAlert();
      e.preventDefault();
      var params = $form.serializeArray();
      var statements = [];

      for (var i = 0; i < params.length; i += 1) {
        var name = params[i].name;

        if (getSubstring(name) === 'id') {
          statements.push(params[i]);
        }
      }

      if (statements.length === 0) {
        showAlert();
      } else if (statements.length === 1) {
        window.open('/billing_statements/' + statements[0].value + '/download_pdf', '_blank');
      } else {
        $form.trigger('submit');
      }
    });
  }

  if ($billing_container) {
    listenToSubmit();
  }
}

var BillingSelect = {
  handleChecked: handleChecked
};
export default BillingSelect;